export const checkСustom = {
    char32: [
        '{ "bitmapText": "#BBBB" },',
        '{ "line": "`OOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOO`", "isBold": true},',
        '{ "line": "@Время терминала: NNNNNNNNNNNNNNN@"},',
        '{ "line": "@Заказ: #BBBBBBBBBBBBBBBBBBBBBBBB@"},',
        '{ "line": "@Кассир: UUUUUUUUUUUUUUUUUUUUUUUU@"},',
        '{ "line": "@Бонусов добавлено: AAAAAAAAAAAAA@", "isBold": true},',
        '{ "line": "@Гостей за столом: GGGGGGGGGGGGGG@", "isBold": true},',
        '{ "line": "@Всего бонусов: VVVVVVVVVVVVVVVVV@", "isBold": true},',
        '{ "line": "@НОМЕР ЗАКАЗА: #BBBBBBBBBBBBBBBBB@", "isBold": true},',
        '{ "line": "@Официант: WWWWWWWWWWWWWWWWWWWWW@", "isBold": true},',
        '{ "line": "@Текущее время: NNNNNNNNNNNNNNNN@", "isBold": true},',
        '{ "line": "@Открыт: CCCCCCCCCCCCCCCCCCCCCCC@", "isBold": true},',
        '{ "line": "@Бонусов списано: LLLLLLLLLLLLLL@", "isBold": true},',
        '{ "line": "@ФИО гостя: XXXXXXXXXXXXXXXXXXXX@", "isBold": true},',
        '{ "line": "*********************************"},',
    ],
    char56: [
        '{ "bitmapText": "#BBBBBB" },',
        '{ "line": "`OOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOO`", "isBold": true},',
        '{ "line": "@Время терминала: NNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNN@"},',
        '{ "line": "@Заказ: #BBBBBBBBBBBBBBBBBBBBBBBBBBBBBBBBBBBBBBBBBBBBBBBB@"},',
        '{ "line": "@Кассир: UUUUUUUUUUUUUUUUUUUUUUUUUUUUUUUUUUUUUUUUUUUUUUUU@"},',
        '{ "line": "@Бонусов добавлено: AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA@", "isBold": true},',
        '{ "line": "@Гостей за столом: GGGGGGGGGGGGGGGGGGGGGGGGGGGGGGGGGGGGGG@", "isBold": true},',
        '{ "line": "@Всего бонусов: VVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVV@", "isBold": true},',
        '{ "line": "@Официант: WWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWW@", "isBold": true},',
        '{ "line": "@Открыт: CCCCCCCCCCCCCCCCCCCCCCCCCCCCCCCCCCCCCCCCCCCCCCCC@", "isBold": true},',
        '{ "line": "@Бонусов списано: LLLLLLLLLLLLLLLLLLLLLLLLLLLLLLLLLLLLLLL@", "isBold": true},',
        '{ "line": "@ФИО гостя: XXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXX@", "isBold": true},',
        '{ "line": "********************************************************"},',
    ]
};

export const checkHeaders = {
    CheckHeader32: {
        origin: [
            '{ "line": "`OOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOO`", "isBold": true},',
            '{ "line": "********************************"},',
            '{ "line": "@Время: NNNNNNNNNNNNNNNNNNNNNNNNN@"},',
            '{ "line": "@Кассир: UUUUUUUUUUUUUUUUUUUUUUUU@"},'
        ],
        custom: checkСustom.char32,
        length: '32'
    },

    CheckHeader56: {
        origin: [
            '{ "line": "`OOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOO`", "isBold": true},',
            '{ "line": "********************************************************"},',
            '{ "line": "@Время терминала: NNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNN@"},',
            '{ "line": "@Заказ: #BBBBBBBBBBBBBBBBBBBBBBBBBBBBBBBBBBBBBBBBBBBBBBBB@"},',
            '{ "line": "@Кассир: UUUUUUUUUUUUUUUUUUUUUUUUUUUUUUUUUUUUUUUUUUUUUUUU@"},'
        ],
        custom: checkСustom.char56,
        length: '56'
    },

    PrecheckHeader32: {
        origin: [
            '{ "line": "`Добро пожаловать!`", "isBold": true},',
            '{ "line": "`SSSSSSSSSSSSSSSSSSSSSSSSS`", "isBold": true},',
            '{ "line": "******************************"},',
            '{ "line": "@Зал: HHHHHHHHHH@Стол: TTTTTTTTTTT"},',
            '{ "line": "@Открыт: CCCCCCCCCCCCCCCCCCC@"},',
            '{ "line": "@Официант: WWWWWWWWWWWWWWWWWWWW@"},',
        ],
        custom: checkСustom.char32,
        length: '32'
    },

    PrecheckHeader56: {
        origin: [
            '{ "line": "`Добро пожаловать!`", "isBold": true},',
            '{ "line": "`SSSSSSSSSSSSSSSSSSSSSSSSSSSSSSSSSSSSSSSSSSSSSSSSSSSSSSSS`", "isBold": true},',
            '{ "line": "********************************************************"},',
            '{ "line": "@Зал: HHHHHHHHHHHHHHHHHHHHHHH@Стол: TTTTTTTTTTTTTTTTTTTTTT"},',
            '{ "line": "@Открыт: CCCCCCCCCCCCCCCCCCCCCCCCCCCCCCCCCCCCCCCCCCCCCCCC@"},',
            '{ "line": "@Официант: WWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWW@"},',
        ],
        custom: checkСustom.char56,
        length: '56'
    },

    GuestTicketHeader32: {
        origin: [
            '{ "line": "`KKKKKKKKKKKKKKKKKKKKKKKK`", "isBold": true},',
            '{ "line": "`OOOOOOOOOOOOOOOOOOOOOOOO`", "isBold": true},',
            '{ "line": "@Стол: TTTTT Зал: HHHHHH Гостей: GGG@"},',
            '{ "line": "@Сотрудник: UUUUUUUUUUUUUU@"},',
            '{ "line": "@Время открытия стола: CCCCCCCCCCCCCCC@"},',
            '{ "line": "@Время терминала: NNNNNNNNNNNNNNNNNN@"},',
        ],
        custom: checkСustom.char32,
        length: '32'
    },

    GuestTicketHeader56: {
        origin: [
            '{ "line": "`KKKKKKKKKKKKKKKKKKKKKKKKKKKKKKKKKKKKKKKKKKKKKKKKKKKKKKKK`", "isBold": true},',
            '{ "line": "`OOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOO`", "isBold": true},',
            '{ "line": "@Стол: TTTTTTTTTT Зал: HHHHHHHHHHHHHHHHHHHHHH Гостей: GGG@"},',
            '{ "line": "@Сотрудник: UUUUUUUUUUUUUUUUUUUUUUUUUUUUUUUUUUUUUUUUUUUUU@"},',
            '{ "line": "@Время открытия стола: CCCCCCCCCCCCCCCCCCCCCCCCCCCCCCCCCC@"},',
            '{ "line": "@Время терминала: NNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNN@"},',
        ],
        custom: checkСustom.char56,
        length: '56'
    },

    KitchenHeader32: {
        origin: [
            '{ "line": "`KKKKKKKKKKKKKKKKKKKKKKKK`", "isBold": true},',
            '{ "line": "`OOOOOOOOOOOOOOOOOOOOOOOO`", "isBold": true},',
            '{ "line": "@Стол: TTTTT Зал: HHHHHH Гостей: GGG@"},',
            '{ "line": "@Сотрудник: UUUUUUUUUUUUUU@"},',
            '{ "line": "@Время открытия стола: CCCCCCCCCCCCCCC@"},',
            '{ "line": "@Время терминала: NNNNNNNNNNNNNNNNNN@"}',
        ],
        custom: checkСustom.char32,
        length: '32'
    },

    KitchenHeader56: {
        origin: [
            '{ "line": "`KKKKKKKKKKKKKKKKKKKKKKKKKKKKKKKKKKKKKKKKKKKKKKKKKKKKKKKK`", "isBold": true},',
            '{ "line": "`OOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOO`", "isBold": true},',
            '{ "line": "@Стол: TTTTTTTTTT Зал: HHHHHHHHHHHHHHHHHHHHHH Гостей: GGG@"},',
            '{ "line": "@Сотрудник: UUUUUUUUUUUUUUUUUUUUUUUUUUUUUUUUUUUUUUUUUUUUU@"},',
            '{ "line": "@Время открытия стола: CCCCCCCCCCCCCCCCCCCCCCCCCCCCCCCCCC@"},',
            '{ "line": "@Время терминала: NNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNN@"},',
        ],
        custom: checkСustom.char56,
        length: '56'
    },

    GuestTicketFooter32: {
        origin: [
            '{ "line": "********************************"},',
        ],
        custom: checkСustom.char32,
        length: '32'
    },

    GuestTicketFooter56: {
        origin: [
            '{ "line": "********************************************************"},',
        ],
        custom: checkСustom.char56,
        length: '56'
    },

    KitchenFooter32: {
        origin: [
            '{ "line": "********************************"},',
            '{ "line": "@JJJJJJJJJJJJJJJJJJJJJJJJJJJJJJJJ@"},',
        ],
        custom: checkСustom.char32,
        length: '32'
    }, 

    KitchenFooter56: {
        origin: [
            '{ "line": "*******************************************************"},',
            '{ "line": "@JJJJJJJJJJJJJJJJJJJJJJJJJJJJJJJJJJJJJJJJJJJJJJJJJJJJJ@"},',
        ],
        custom: checkСustom.char56,
        length: '56'
    }, 

    PrecheckFooter32: {
        origin: [
            '{ "line": "`Спасибо! Ждем вас снова!////////`", "isBold": true},',
        ],
        custom: checkСustom.char32,
        length: '32'
    }, 
    PrecheckFooter56: {
        origin: [
            '{ "line": "`Спасибо! Ждем вас снова!////////`", "isBold": true},',
        ],
        custom: checkСustom.char56,
        length: '56'
    }, 
}
